// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__nW9j6","actionsCol":"EnrolledClinics_actionsCol__2JY8a"};